/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** TargetSystem */
export enum TargetSystem {
  ZAKEN = "ZAKEN",
  KOPPELEN = "KOPPELEN",
  BEZWAREN = "BEZWAREN",
}

/** ScheduleStatus */
export enum ScheduleStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED",
  ERROR = "ERROR",
}

/** CertificateType */
export enum CertificateType {
  Pki = "pki",
  ZaakClient = "zaak_client",
}

/** CertificateStatus */
export enum CertificateStatus {
  PENDING = "PENDING",
  CSR_READY = "CSR_READY",
  CSR_DOWNLOADED = "CSR_DOWNLOADED",
  CERT_UPLOADED = "CERT_UPLOADED",
  INSTALL_SCHEDULED = "INSTALL_SCHEDULED",
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  ERROR = "ERROR",
}

/** AuditLogOut */
export interface AuditLogOut {
  /**
   * Created
   * @format date-time
   */
  created: string;
  /**
   * Lastmodified
   * @format date-time
   */
  lastModified: string;
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Organizationid */
  organizationId: string;
  /**
   * Certificateid
   * @format uuid
   */
  certificateId: string;
  /** Description */
  description: string;
  /** User */
  user: string;
}

/** Body_upload_certificate_api_v1_certificate__id__upload_post */
export interface BodyUploadCertificateApiV1CertificateIdUploadPost {
  /** File */
  file: File | Blob;
}

/** CertificateCSROut */
export interface CertificateCSROut {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Filename */
  filename: string;
  /**
   * Mimetype
   * @default "application/x-pem-file"
   */
  mimeType?: "application/pkcs10" | "application/x-pem-file" | "text/plain";
  /** Data */
  data: string;
}

/** CertificateCreate */
export interface CertificateCreate {
  /**
   * Municipalityid
   * @format uuid
   */
  municipalityId: string;
  /** Contactnaam */
  contactNaam: string;
  /**
   * Contactemail
   * @format email
   */
  contactEmail: string;
  /** Contacttelefoon */
  contactTelefoon: string;
  type: CertificateType;
  targetSystem: TargetSystem;
  /** @default "PENDING" */
  status?: CertificateStatus;
  /** Verloopdatum */
  verloopDatum?: string | null;
  /** Metadata */
  metaData?: Record<string, any> | null;
}

/** CertificateFileOut */
export interface CertificateFileOut {
  /**
   * Certificate ID
   * @format uuid
   */
  id: string;
  /** Filename */
  filename: string;
  /**
   * Mimetype
   * @default "application/x-pem-file"
   */
  mimeType?: string;
  /** Data */
  data: string;
}

/** CertificateOut */
export interface CertificateOut {
  /**
   * Unique identifier
   * @format uuid
   */
  id: string;
  /**
   * Municipality ID
   * @format uuid
   */
  municipalityId: string;
  /** Contactnaam */
  contactNaam: string;
  /**
   * Contactemail
   * @format email
   */
  contactEmail: string;
  /** Contacttelefoon */
  contactTelefoon: string;
  type: CertificateType;
  status: CertificateStatus;
  targetSystem: TargetSystem;
  /** Verloopdatum */
  verloopDatum?: string | null;
  /** Metadata */
  metaData?: Record<string, any> | null;
  /**
   * Created
   * @format date-time
   */
  created: string;
  /**
   * Lastmodified
   * @format date-time
   */
  lastModified: string;
}

/** CertificateUpdate */
export interface CertificateUpdate {
  /** Municipalityid */
  municipalityId?: string | null;
  /** Contactnaam */
  contactNaam?: string | null;
  /** Contactemail */
  contactEmail?: string | null;
  /** Contacttelefoon */
  contactTelefoon?: string | null;
  type?: CertificateType | null;
  targetSystem?: TargetSystem | null;
  status?: CertificateStatus | null;
  /** Verloopdatum */
  verloopDatum?: string | null;
  /** Metadata */
  metaData?: Record<string, any> | null;
}

/** ConfigurationCreate */
export interface ConfigurationCreate {
  /** Welcome message */
  welcomeMessage?: string | null;
}

/** ConfigurationOut */
export interface ConfigurationOut {
  /**
   * Unique identifier
   * @format uuid
   */
  id: string;
  /** Welcome message */
  welcomeMessage?: string | null;
}

/** ConfigurationUpdate */
export interface ConfigurationUpdate {
  /** Welcome message */
  welcomeMessage?: string | null;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/**
 * InstanceOut
 * Schema voor een enkele omgeving / instance.
 */
export interface InstanceOut {
  /** Id */
  id: string;
  /** Fqdn */
  fqdn: string;
  /** Label */
  label?: string | null;
  /** Hosts */
  hosts: string[];
  /** Type */
  type?: string | null;
}

/** InterfaceOut */
export interface InterfaceOut {
  /** Id */
  id: number;
  /** Uuid */
  uuid: string;
  /** Name */
  name: string;
  /** Module */
  module: string;
  /** Active */
  active: number;
  /** Interface Config */
  interface_config?: Record<string, any> | null;
}

/** MunicipalityCreate */
export interface MunicipalityCreate {
  /** Organisatiennaam */
  organisatienNaam: string;
  /** Plaatsnaam */
  plaatsNaam: string;
  /** Provincie */
  provincie: string;
  /** Contactnaam */
  contactNaam: string;
  /** Contacttelefoon */
  contactTelefoon: string;
  /**
   * Contactemail
   * @format email
   */
  contactEmail: string;
}

/** MunicipalityOut */
export interface MunicipalityOut {
  /**
   * Unique identifier
   * @format uuid
   */
  id: string;
  /** Organisatienaam */
  organisatienNaam: string;
  /** Plaatsnaam */
  plaatsNaam: string;
  /** Provincie */
  provincie: string;
  /** Contactpersoon */
  contactNaam: string;
  /** Telefoonnummer */
  contactTelefoon: string;
  /**
   * E-mailadres
   * @format email
   */
  contactEmail: string;
}

/** MunicipalityUpdate */
export interface MunicipalityUpdate {
  /** Organisatiennaam */
  organisatienNaam?: string | null;
  /** Plaatsnaam */
  plaatsNaam?: string | null;
  /** Provincie */
  provincie?: string | null;
  /** Contactnaam */
  contactNaam?: string | null;
  /** Contacttelefoon */
  contactTelefoon?: string | null;
  /** Contactemail */
  contactEmail?: string | null;
}

/** OrganizationOut */
export interface OrganizationOut {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Organizationid */
  organizationId: string;
}

/** ScheduleCreate */
export interface ScheduleCreate {
  /**
   * Certificateid
   * @format uuid
   */
  certificateId: string;
  /**
   * Installationdatum
   * @format date-time
   */
  installationDatum: string;
  /** @default "PENDING" */
  status?: ScheduleStatus;
  /** Statusdescription */
  statusDescription?: string | null;
}

/** ScheduleOut */
export interface ScheduleOut {
  /**
   * Unique identifier
   * @format uuid
   */
  id: string;
  /**
   * Certificate ID
   * @format uuid
   */
  certificateId: string;
  /**
   * Installationdatum
   * @format date-time
   */
  installationDatum: string;
  status: ScheduleStatus;
  /** Statusdescription */
  statusDescription?: string | null;
  /**
   * Created
   * @format date-time
   */
  created: string;
  /**
   * Lastmodified
   * @format date-time
   */
  lastModified: string;
}

/** ScheduleUpdate */
export interface ScheduleUpdate {
  /** Certificateid */
  certificateId?: string | null;
  /** Installationdatum */
  installationDatum?: string | null;
  status?: ScheduleStatus | null;
  /** Statusdescription */
  statusDescription?: string | null;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
  /** Input */
  input?: any;
  /** Context */
  ctx?: object;
}
